module.exports = "https://www.gc-pro.gnp.com.mx/ab1e3341203dbfa434018cb449493fd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tarjeta-gmm.svg
// module id = 1863
// module chunks = 0